import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
export function map(obj) {
  var _context;

  return _filterInstanceProperty(_context = _Object$keys(obj)).call(_context, function (key) {
    return obj[key];
  });
}